export default __webpack_public_path__ + "static/media/uae-support.9234b418.png";